import { html } from 'lit';
const SnowPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12.1 2a1 1 0 0 1 1 1v1.636l.993-.993a1 1 0 1 1 1.414 1.414L13.1 7.464v2.804l2.258-1.303 1.193-3.581a1 1 0 1 1 1.898.632l-.48 1.441 1.408-.813a1 1 0 1 1 1 1.732l-1.612.93 1.652.368a1 1 0 1 1-.434 1.952l-3.78-.84-2.093 1.208 2.107 1.217 3.766-.837a1 1 0 1 1 .434 1.952l-1.637.364 1.634.944a1 1 0 1 1-1 1.732l-1.45-.838.485 1.456a1 1 0 0 1-1.898.632l-1.198-3.595-2.253-1.3v2.815l2.407 2.407a1 1 0 0 1-1.414 1.414l-.993-.993V21a1 1 0 1 1-2 0v-1.636l-.993.993a1 1 0 0 1-1.414-1.414l2.407-2.407v-2.804l-2.258 1.304-1.193 3.58a1 1 0 1 1-1.898-.632l.48-1.441-1.407.813a1 1 0 1 1-1-1.732l1.611-.93-1.652-.368a1 1 0 0 1 .434-1.952l3.78.84 2.113-1.22-2.098-1.211-3.795.843a1 1 0 1 1-.434-1.952l1.667-.37-1.624-.938a1 1 0 0 1 1-1.732l1.4.809-.475-1.427a1 1 0 1 1 1.898-.632L8.837 8.95l2.263 1.306V7.464L8.693 5.057a1 1 0 0 1 1.414-1.414l.993.993V3a1 1 0 0 1 1-1" clip-rule="evenodd"/>
  </svg>
`;
export default SnowPanel;
